import { render, staticRenderFns } from "./FlaggingHeader.vue?vue&type=template&id=040fd3c0&scoped=true"
import script from "./FlaggingHeader.vue?vue&type=script&lang=js"
export * from "./FlaggingHeader.vue?vue&type=script&lang=js"
import style0 from "./FlaggingHeader.vue?vue&type=style&index=0&id=040fd3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040fd3c0",
  null
  
)

export default component.exports